import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { LeaderboardPage } from "@/features/leaderboard/LeaderboardPage";

// ?metric=<metric>&period=<period>: the number ranked and the period it covers (won amount, this month when none is given)
const search = z.object({
  metric: z.enum(["won", "calls", "meetings", "booked", "first_touch", "response", "attainment", "goal_days"]).catch("won"),
  period: z.enum(["day", "week", "month", "quarter"]).catch("month"),
});

export const Route = createFileRoute("/_app/leaderboard/")({
  validateSearch: search,
  component: () => {
    const s = Route.useSearch();
    return <LeaderboardPage metric={s.metric} period={s.period} />;
  },
});
